import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import TableNewPaginanation from "../../../services/TableNewPaginanation";
import { redirectUrl } from "../../../services/GlobalUrls";

const formatDateTime = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
};

const IncidentLogsList = ({ ...props }) => {
  const [incidentlogs, setIncidentLogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setIncidentLogs(props.incidentlogs || []);
    setCurrentPage(1);
  }, [props.incidentlogs]);

  const viewIncidentLogData = (incidentLog) => {
    const id = incidentLog.incident_log_id;
    if (id) {
      sessionStorage.setItem("incidentLogViewId", id);
      sessionStorage.setItem("incidentLogViewMode", "true");
      redirectUrl("/create-incident-log");
    }
  };

  // Search Filter - Start
  const matchesSearchText = (incidentLog) => {
    const searchText = inputValue.toLowerCase();
    return (
      (incidentLog.incident_log_service_user_name || "")
        .toLowerCase()
        .includes(searchText) ||
      (incidentLog.incident_log_accident_incident_location || "")
        .toLowerCase()
        .includes(searchText) ||
      (incidentLog.incident_log_accident_incident_datetime || "")
        .toLowerCase()
        .includes(searchText) ||
      (incidentLog.incident_log_accident_incident_report || "")
        .toLowerCase()
        .includes(searchText)
    );
  };

  const filterRows = incidentlogs ? incidentlogs.filter(matchesSearchText) : [];
  // Search Filter - End

  const onPageChange = (page, pageSize = recordsPerPage) => {
    setCurrentPage(page);
    setRecordsPerPage(pageSize);
  };

  const startIndex =
    recordsPerPage === "all" ? 0 : (currentPage - 1) * recordsPerPage;
  const endIndex =
    recordsPerPage === "all" ? filterRows.length : startIndex + recordsPerPage;

  return (
    <React.Fragment>
      <div className="m-b30 wrapper">
        {/* Search Start */}
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-8"></div>
            <div className="col-sm-4 mt-2">
              <div className="form-group form-group-default">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search here"
                  style={{ height: "40px" }}
                  onInput={(e) => setInputValue(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        {/* Search End */}

        <div className="courses-section">
          <table className="courses-table">
            <thead className="thead-dark">
              <tr>
                <th className="col-3 text-center" scope="col">
                  Date & Time
                </th>
                <th className="col-3 text-center" scope="col">
                  Service User Name
                </th>
                <th className="col-3 text-center" scope="col">
                  Location
                </th>
                <th className="col-3 text-center" scope="col">
                  Action
                </th>
              </tr>
            </thead>
            <tbody id="myTable">
              {filterRows &&
                filterRows.length > 0 &&
                filterRows.slice(startIndex, endIndex).map((incident_log, i) => (
                  <tr key={i}>
                    <td className="col-3 text-center">
                      {formatDateTime(
                        incident_log.incident_log_accident_incident_datetime
                      )}
                    </td>
                    <td className="col-3 text-center">
                      {incident_log.incident_log_service_user_name || "-"}
                    </td>
                    <td className="col-3 text-center">
                      {incident_log.incident_log_accident_incident_location ||
                        "-"}
                    </td>
                    <td className="col-3 text-center">
                      <button
                        className="btn btn-primary btn-sm text-white"
                        onClick={() => viewIncidentLogData(incident_log)}
                      >
                        <i className="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              {incidentlogs.length == 0 && (
                <tr>
                  <td colSpan="100" className="text-center">
                    No Incident Logs Found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {filterRows.length > 0 && (
          <TableNewPaginanation
            totalItems={filterRows.length}
            pageSize={recordsPerPage}
            currentPage={currentPage}
            onPageChange={onPageChange}
            isDropdown={true}
            isPaggination={true}
          />
        )}
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    incidentlogs: state.incidentlogs.incidentlogs,
  };
};

export default connect(mapStateToProps)(IncidentLogsList);
